import { Notepad2 } from 'iconsax-react';
import { Button } from '@src/design-system/button';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@src/design-system/dialog';
import type { TLead } from '@src/shared/types/lead';
import { LeadNotesAddDialog } from '@features/leads/pages/list/dialogs/lead-notes-add-dialog';
import { dayjsUtils } from '@src/shared/utils/helpers/dayjs';

export function LeadNotesCell({
  lead,
  nextFollowUpDate,
}: {
  lead: TLead;
  nextFollowUpDate?: string;
}) {
  return (
    <div className='flex items-center gap-2'>
      <Dialog>
        <DialogTrigger>
          <Button
            size='sm'
            variant='ghost'
            className='border-0 hover:bg-primary-50 text-active-border'
            disabled={!lead.has_notes && !nextFollowUpDate}
          >
            <Notepad2 />
            <span className='text-sm font-normal'>
              {nextFollowUpDate
                ? dayjsUtils(nextFollowUpDate).format('DD MMM YYYY')
                : null}
            </span>
          </Button>
        </DialogTrigger>

        <DialogContent>
          <LeadNotesAddDialog leadId={lead.id} />
        </DialogContent>
      </Dialog>
    </div>
  );
}
